
const w3Debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback(...args);
      }, wait);
    };
  }
  
    function clearProcessing(){
      var errors = document.querySelector('.product-options-errors');
      if (errors != null){
        var btn =  document.querySelector('.product-form--atc-button');
        if (btn != null){
          btn.classList.remove("processing");
          btn.removeAttribute('disabled');
        }
      }
    }
  
  
     document.querySelector('body').addEventListener("productOptionsPriceChangeJS", function(e) {
  
     //remove all previous prices
     var priceSpans = document.querySelectorAll('.w3-selected-price');
       priceSpans.forEach((s) =>{
         s.remove();
       });
       
     var price = e.detail[0];
     var container = e.detail[1];
     var products = e.detail[2];
     var ProductPrices = e.detail[3];
  
     //debug
     //console.log(price);
     //console.log(container);
    // console.log(products);
     //console.log(ProductPrices);
  
       if(ProductPrices != null){
         ProductPrices.forEach((i) =>{
           var fieldID = i.field;
           var variantID = i.variantId;
           
           var field = document.querySelectorAll('[data-field-id="' + fieldID + '"]')[0];
           if (field != null){
             //get label
             var label = field.querySelector(".product-options-field-name");
             //add price span at the end of the label
             var price = document.createElement("span");
             price.classList.add('w3-selected-price');
  
             //find matching product
             const product = products.find((x) => x.variant_id == variantID);
             if (product != null){
               if (product.price > 0){
                  var formattedPrice =  Shopify.formatMoney(product.price, );
                  price.innerHTML = "+" + formattedPrice ;
                 label.appendChild(price);
               }
              
             }
             
           }
         })
       }
     
     });
  
  
      document.querySelector('.product-form--atc-button')?.addEventListener("click", function(e) {
        var btn =  document.querySelector('.product-form--atc-button');
        if (btn != null){
          btn.classList.add("processing");
          //btn.setAttribute('disabled', 'disabled');
  
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === "childList"){
                 w3Debounce(clearProcessing(), 3000)
              }
           });
                     
          // mutations.forEach((mutation) => {
          //     console.log(mutation.type, mutation.target.id, mutation.attributeName);
          
          //     if (mutation.type === "childList" && mutation.target.id === "target") {
          //       // After receiving the notification that the child was removed,
          //       // further modifications to the detached subtree no longer trigger the observer.
          //       child.setAttribute("data-bar", "");
          //     }
          //   });
          });
  
          observer.observe(document.querySelector('.w3-product-options'), {
            attributes: true,
            childList: true,
            subtree: true,
          });
          
        }
      });
  
   document.querySelector('.w3-cart-checkout')?.addEventListener("click", function(e) {
     checkCart();
    });
     document.querySelector('.w3-cart-checkout-footer')?.addEventListener("click", function(e) {
     checkCart();
    });
  
     function  checkCart(){
       var productsToUpdate = [];
        var productsToAdd = [];
     
         fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => { 
          var cartContents = data;
          var cartItems = data.items;
  
          if (cartItems.length > 0){
            cartItems.forEach((i) => {
              if (typeof i.properties['_options_addon_products'] != 'undefined'){
                var optionsGuid = i.properties['_options_group_id'];
                var optionsQty = i.quantity;
                var addOns = JSON.parse(i.properties['_options_addon_products']);
                addOns.forEach((a) => {
                  var ext = cartItems.filter((x)=> x.variant_id == a.variantId && x.properties['_options_action'] == a.actionID && x.properties['_options_group_id']==optionsGuid);
                  if(ext.length == 1){
                    //check quantity
                    if (ext[0].quantity != optionsQty){
                      
                      var p = {
                        key: ext[0].key,
                        quantity: optionsQty
                      }
                      productsToUpdate.push(p);
                    }
                  }
                  if(ext.length == 0){
                    var product = {
                        quantity: optionsQty,
                        id: a.variantId,
                        properties: {
                            "_options_group_id": optionsGuid,
                            "_options_hidden": 'true',
                            "_options_action": a.actionID
                        }
                    }
                    productsToAdd.push(product);
                  }
                });
              }
            });
  
           updateCart(productsToUpdate, productsToAdd)
  
          }
        })
     }
     
     function updateCart(productsToUpdate, productsToAdd){
       var btn = document.querySelector('.header-checkout-btn');
       
       Promise.allSettled([
          addProducts(productsToAdd),
          updateProducts(productsToUpdate)
        ]).then((results) =>{
         window.location.href = "/checkout";
       }).catch(err =>
          console.log(err)
        );
     }
  
  
     function addProducts(productList){
        if(productList.length <= 0){return null;}
       
        let formData = {
           'items': productList
          };
  
         return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
            })
            .then((response)=>response.json())
            .then((responseJson)=>{return responseJson})
            .catch((error) => {
              console.error('Error:', error);
            });
     }
  
     function updateProducts(updateList){
       if(updateList.length <= 0){return null;}
       
       var formData = new FormData();
       updateList.forEach((u) => {
         formData.append("updates[" + u.key + "]", u.quantity);
       });
       
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body:  formData
        })
        .then(response => response.json())
        .then(data => {return data})
        .catch((error) => {
          console.error('Error:', error);
        });
     }
  
      
  
      function fieldAddedCallback(field, element) {
        var option = element[0];
        
        var hiddenInput = option.querySelector("input");
        if(hiddenInput != null){
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              var fieldID = option.dataset.fieldId;

              if(hiddenInput.value && hiddenInput.value != ''){
                option.classList.remove("has-error")
                var errorMessage = document.querySelector("span[data-error-field-id='"+ fieldID + "']");
                if(errorMessage){
                  errorMessage.remove();
                }

                var errorCount = document.querySelectorAll(".product-options-errors span"); 
                if (errorCount.length <= 0){
                  var errorPanel = document.querySelector(".product-options-errors");
                   if(errorPanel != null){
                    errorPanel.style.display = "none";
                  }
                }               
              
              }
           });

          });

          observer.observe(hiddenInput, {
            attributes: true,
            childList: true,
            subtree: true,
          });

        }
        

          
       if(option.classList.contains("info-popover")){
         option.addEventListener('mouseleave', () => {
            popover.classList.remove("show");
          });
         
         var desc = option.querySelector(".product-options-field-description");
         if (desc){
           desc.style.display = "none";
  
           //get name div
           var title = option.querySelector(".product-options-field-name");
  
           //get description div
           var popover =  option.querySelector(".product-options-field-description");
           
           
           //add hover trigger
           var trigger = document.createElement("span");
           trigger.innerText  = "What is this?";
           trigger.classList.add("w3InfoPopover");
  
           title.appendChild(trigger);
  
           trigger.addEventListener('mouseover', () => {
            popover.classList.add("show");
          });
           
         }
  
         
       }
  }

    document.querySelector('body').addEventListener("productOptionsLoadedJS", function(e) {
     
        var optionsLoading = document.querySelector('.w3-options-loading');
        if (optionsLoading){
          optionsLoading.classList.add("hidden");
        }

        var atcBlock = document.querySelector(".product-form--atc");
        if (atcBlock){
          atcBlock.style.display = "block";
        }

        var w3Form = document.querySelector(".w3-form-ready");
        if (w3Form){
          w3Form.style.display = "block";
        }
      
   });

   document.querySelector('body').addEventListener("productOptionsValidationErrors", function(e) {

    var allFields = document.querySelectorAll(".product-options-control-container");
    allFields.forEach(x=>{
      x.classList.remove("has-error");
    })

    e.detail[0].forEach(err => {
      var field = document.querySelector("div[data-field-id='" + err.field_id + "']");
      if(field != null){
        field.classList.add("has-error");
      }
    });
      
   });
  
      
  
      
  
  
  
  
  
  
     